export const getGtagClientId = () => {
  function getCookie(name) {
    var matches = document.cookie.match(
      new RegExp(
        '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
      )
    );

    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  var _ga = getCookie('_ga');
  // _ga = 'GA1.2.243828842.1683526256'

  if (!_ga) {
    return false;
  }

  if (/GA1.2./.test(_ga)) {
    return _ga.replace(/^GA1.2./, '');
  }
};


export const googleMeasurementSecret = data => {
  const IS_PROD = process.env.REACT_APP_BUILD === 'prod';
  const PROJECT_NAME = process.env.REACT_APP_PROJECT_NAME
  const LIVRES = 'livres'
  const BEWRITERS = 'bewriters'

  const API_SECRET = {
    [LIVRES]: '4dOpHZfySV6Qadn3J_gjvA',
    [BEWRITERS]: 'RYnZ160vSoeP3AHHcf60hg'
  }

  const MEASURMENT_ID = {
    [LIVRES]: 'G-G8VKS5CGFC',
    [BEWRITERS]: 'G-7KJYVZXDJR'
  }

  if (!IS_PROD) {
    console.info('google measurement event:', data.event);
    console.info('clientId:', getGtagClientId());
    return false;
  }

  const { event, userId } = data;

  const clientId = getGtagClientId() || 'no client id';
  const gaSessionId = clientId
    ? clientId.split('.')[1] || 'no session id'
    : 'no client id with current session';

  const payload = JSON.stringify({
    client_id: clientId,
    user_id: userId.toString(),
    non_personalized_ads: false,
    events: [
      {
        name: event,
        params: {
          items: [],
          ga_session_id: gaSessionId,
        },
      },
    ],
  });

  return fetch(
    `https://google-analytics.com/mp/collect?api_secret=${API_SECRET[PROJECT_NAME]}&measurement_id=${MEASURMENT_ID[PROJECT_NAME]}`,
    {
      method: 'POST',
      body: payload,
    }
  )
    .then(resp => resp)
    .catch(error => error);
};



// WEBPACK FOOTER //
// ./src/utils/gaUtils.js